"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cron = void 0;
const CronField_1 = __importDefault(require("./CronField"));
// EXAMPLES
// 	'0 8 * * *', // daily
// 	'0 8 * * 1,2,3,4,5', // weekly
// 	'0 8 1,2 * *', // monthly by day
// 	'0 8 * * 6#1', // monthly by week
// 	'0 8 1,2 12 *', // anually
class Cron {
    constructor() {
        this.minute = new CronField_1.default();
        this.hour = new CronField_1.default();
        this.dayOfMonth = new CronField_1.default(); // SUN MON TUE WED THU FRI
        this.month = new CronField_1.default();
        this.dayOfWeek = new CronField_1.default();
    }
    toString() {
        return [
            this.minute.toString(),
            this.hour.toString(),
            this.dayOfMonth.toString(),
            this.month.toString(),
            this.dayOfWeek.toString(),
        ].join(' ');
    }
}
exports.Cron = Cron;
exports.default = Cron;
